import {ANALYTICS} from 'constants/actions';
import {
    CategoryProductFrameType,
    CategoryProductLensesType,
} from 'reducers/category/categoryItemsType';
import {SimpleProductType} from '@typescript/productTypes';
import {EmptyActionType} from '@typescript/common/actionTypes';

export type SelectedProductType = (SimpleProductType | CategoryProductLensesType) & {index: number};

/**
 * Get data of selected product
 * @param {CategoryProductLensesType} product - simple product
 * @param {string} actionField - category
 * @returns {EmptyActionType<{product: CategoryProductLensesType, actionField: string}>} - action
 */
export function selectedProduct(
    product: SelectedProductType,
    actionField?: string,
): EmptyActionType<{
    product: SelectedProductType;
    actionField?: string;
}> {
    return {
        type: ANALYTICS.EEC_PRODUCT_CLICK,
        meta: {
            product,
            actionField,
        },
    };
}

/**
 * Get product when color changes
 * @param {CategoryProductFrameType} product - product
 * @returns {EmptyActionType<{product: CategoryProductFrameType}>} - action
 */
export function changeColorToCategory(
    product: CategoryProductFrameType[],
): EmptyActionType<{product: CategoryProductFrameType[]}> {
    return {
        type: ANALYTICS.CATEGORY_COLOR_CHANGE,
        meta: {
            product,
        },
    };
}

/**
 * Get product when option changes
 *
 * @param {number} id - product id
 * @returns {EmptyActionType<{id: number}>} - action
 */
export function changeOptionToPDP(id: number): EmptyActionType<{id: number}> {
    return {
        type: ANALYTICS.PDP_ATTR_CHANGE,
        meta: {
            id,
        },
    };
}

/**
 * Get data when the user uses the search
 *
 * @param {string} value - search value
 * @returns {EmptyActionType<{value: string}>} - action
 */
export function searchKeywords(value: string): EmptyActionType<{value: string}> {
    return {
        type: ANALYTICS.KEYWORD_SEARCH,
        meta: {
            value,
        },
    };
}
